import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var ConcurSvg = function ConcurSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB00",
    d: "M11.303 14.92c-1.684 0-3.05-1.297-3.05-2.896 0-1.6 1.366-2.896 3.05-2.896a2.97 2.97 0 0 1 2.128.84L15 8.453A5.34 5.34 0 0 0 11.266 7C8.357 7 6 9.24 6 12s2.357 5 5.266 5A5.63 5.63 0 0 0 15 15.546l-1.569-1.465a3.26 3.26 0 0 1-2.128.839"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB00",
    d: "M16 11.018a1 1 0 0 0-.926.616.98.98 0 0 0 .226 1.082c.29.282.723.362 1.095.203a.99.99 0 0 0 .605-.928.995.995 0 0 0-1-.991z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB00",
    fillRule: "evenodd",
    d: "M22 22H2V2h20zM4.225 4.225v15.5h15.5v-15.5z",
    clipRule: "evenodd"
  }));
};
export var Concur = function Concur(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: ConcurSvg
  }));
};